export default {
  TEXT: 'TEXT',
  TOTAL: 'TOTAL',
  TITLE: 'TITLE',
  DIVIDER: 'DIVIDER',
};
